/* P2R Global — lightweight touch press feedback for buttons and cards.
   Applied after a short delay, removed on release or as soon as the finger starts scrolling, so it never interferes with scrolling or navigation. */
(function () {
  if (window.__p2rTouch) return; window.__p2rTouch = true;
  var S = '.button,.button-secondary,.button-custom,.shopify-payment-button__button--unbranded,.p2r-btn,.p2r-card,.p2r-cardx,product-card';
  var cur = null, t = null;
  // An empty touchstart listener lets iOS Safari apply :active press styles to icons and controls.
  document.addEventListener('touchstart', function () {}, { passive: true });
  function clear() { clearTimeout(t); t = null; if (cur) { cur.classList.remove('is-pressed'); cur = null; } }
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' || !e.target.closest) return;
    var el = e.target.closest(S);
    if (!el || el.classList.contains('button-unstyled') || el.disabled) return;
    clear(); t = setTimeout(function () { cur = el; el.classList.add('is-pressed'); }, 60);
  }, { passive: true });
  ['pointerup', 'pointercancel', 'scroll', 'dragstart', 'contextmenu'].forEach(function (ev) { window.addEventListener(ev, clear, { passive: true, capture: true }); });
})();
